import { showErrorAlert } from "../helpers/alert";
import apiClient from "../helpers/apiClient";
import { handleApiError, parseApiErrors } from "../utils/handleApiError";

export async function getReferralsCatalog(): Promise<any>{
    try {
        const { data } = await apiClient.get(`/members/referrals/catalog/`,{});
        return data;
    } catch (error) {
        handleApiError(error, {});
    }
}


export async function createMemeberReferral(data:any) {
    try {
        const response = await apiClient.post(`/members/referrals/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
}
